module.exports = __webpack_public_path__ + "static/img/icon-collect.98ff38d2.svg";